// AppLayout.tsx
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { DeskTopBar } from "../components/DeskTopBar";
import { usePreloadPatientsAutocomplete } from "../hooks/usePreloadPatientsAutocomplete";
import { useStoreIsLoggedIn } from "../state/useAuthStore";
import { AuthGuard } from "../components/AuthGuard";
import { Layout } from "./Layout";
import { useLanguagePreference } from "../hooks/useLanguagePreference";
import { RouteLoadingFallback } from "../components/RouteLoadingFallback";

export const AppLayout: React.FC = () => {
  const isLoggedIn = useStoreIsLoggedIn();

  // Only preload patients autocomplete when user is authenticated
  usePreloadPatientsAutocomplete(isLoggedIn);

  // Applies the user's stored language (or the account's, if they have no override)
  useLanguagePreference(isLoggedIn);

  return (
    <AuthGuard>
      <Layout topBarComponent={<DeskTopBar />}>
        <Suspense fallback={<RouteLoadingFallback />}>
          <Outlet />
        </Suspense>
      </Layout>
    </AuthGuard>
  );
};
